export default  {"src":"/_next/static/image/public/assets/icons/bullet-point.5e15d5fffd021270137527fd1b7f61af.svg","height":15,"width":15};